/** File upload trigger. Wraps React Aria FileTrigger. */
import {
  FileTrigger as AriaFileTrigger,
  type FileTriggerProps as AriaFileTriggerProps,
} from 'react-aria-components';

export function FileTrigger(props: AriaFileTriggerProps) {
  return <AriaFileTrigger {...props} />;
}
